export class ModalActivityParameters {
    public static readonly WIDTH = "600px";
    public static readonly HEIGHT = "540px";
    public static readonly DISABLE_CLOSE = true;
}